export default __webpack_public_path__ + "static/media/portal.78c61a44.png";